import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ShiftClosureService } from '../../core/services/shift-closure.service';
import { PreviewPdfShiftClosureDto } from '../../core/dtos/update-record.dto';

@Component({
  selector: 'app-pdf-preview-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './pdf-preview-modal.component.html',
  styleUrls: ['./pdf-preview-modal.component.scss']
})
export class PdfPreviewModalComponent implements OnInit {
  pdfUrl: SafeResourceUrl | null = null;
  isLoadingPdf = false;
  errorMessage: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<PdfPreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      shiftClosureId: number;
      previewPayload?: PreviewPdfShiftClosureDto; // Opcional: datos del formulario para previsualización
    },
    private shiftClosureService: ShiftClosureService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnInit(): void {
    this.loadPdfPreview();
  }

  private loadPdfPreview(): void {
    this.isLoadingPdf = true;
    this.errorMessage = null;

    // Si tenemos datos del formulario (previewPayload), usar el método de previsualización con datos
    if (this.data.previewPayload) {
      this.shiftClosureService.getShiftClosurePdfPreview(this.data.previewPayload).subscribe({
        next: (pdfBlob: Blob) => {
          this.handlePdfResponse(pdfBlob);
        },
        error: err => {
          this.handlePdfError(err);
        }
      });
    } else {
      // Si no tenemos datos del formulario, usar el método simple con parámetro de previsualización
      this.shiftClosureService.getShiftClosurePdf(this.data.shiftClosureId, true).subscribe({
        next: (pdfBlob: Blob) => {
          this.handlePdfResponse(pdfBlob);
        },
        error: err => {
          this.handlePdfError(err);
        }
      });
    }
  }

  private handlePdfResponse(pdfBlob: Blob): void {
    // Crear URL del PDF
    const pdfObjectUrl = URL.createObjectURL(pdfBlob);
    
    // Abrir el PDF en una nueva pestaña
    const newTab = window.open(pdfObjectUrl, '_blank');
    
    if (newTab) {
      // Si la pestaña se abrió correctamente, esperar un poco antes de cerrar el modal
      setTimeout(() => {
        this.isLoadingPdf = false;
        this.dialogRef.close();
      }, 1000); // Esperar 1 segundo para que el usuario vea que se abrió
    } else {
      // Si no se pudo abrir la pestaña (bloqueador de popups), mostrar en el modal
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfObjectUrl);
      this.isLoadingPdf = false;
    }
  }

  private handlePdfError(err: any): void {
    this.errorMessage = 'Error al cargar la previsualización del PDF.';
    this.isLoadingPdf = false;
    console.error('Error al cargar el PDF:', err);
  }

  close(): void {
    this.dialogRef.close();
  }  downloadPdf(): void {
    if (!this.data.shiftClosureId) {
      console.error('No se puede descargar el PDF porque no existe un ID de cierre.');
      return;
    }

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const dateString = `${day}-${month}-${year}`;

    // Usar la misma lógica que en loadPdfPreview
    const downloadObservable = this.data.previewPayload
      ? this.shiftClosureService.getShiftClosurePdfPreview(this.data.previewPayload)
      : this.shiftClosureService.getShiftClosurePdf(this.data.shiftClosureId, true);

    downloadObservable.subscribe({
      next: blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `shift_closure_preview_${this.data.shiftClosureId}_${dateString}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: err => {
        console.error('Error al descargar el PDF:', err);
      }
    });
  }
}
